/**
 * Teacher-feedback auth user document at:
 * `teacherFeedback/auth/users/{uid}`
 *
 * Caches per-course resolved Zoom user ids (see teacher-feedback session UI).
 * The parent document can coexist with subcollections such as `roles`.
 */

import {z} from 'zod';

import {TEACHER_FEEDBACK_COLLECTION} from './userRole';

// ============================================================================
// Document schema
// ============================================================================

export const TeacherFeedbackAuthUserSchema = z.object({
  /**
   * Cached Zoom user document id per course, written after the first successful
   * match against `zoomUsers` enrollment + email.
   */
  courseZoomUserIds: z.record(z.string(), z.string()).optional(),
});

export type TeacherFeedbackAuthUser = z.infer<
  typeof TeacherFeedbackAuthUserSchema
>;

// ============================================================================
// Paths
// ============================================================================

/**
 * Path: `teacherFeedback/auth/users/{uid}`
 */
export function getTeacherFeedbackAuthUserDocumentPath({
  uid,
}: {
  uid: string;
}): string {
  return `${TEACHER_FEEDBACK_COLLECTION}/auth/users/${uid}`;
}
